import APIService from './APIService';

export default {
  getRelatorios() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/vinculo-conciliacao/get-relatorios')
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error));
    });
  },
  salvarRelatorio(postData) {
    return APIService.apiCall().post('/vinculo-conciliacao/salvar-relatorio', JSON.stringify(postData));
  },
  deletarRelatorio(id) {
    return APIService.apiCall().delete(`/vinculo-conciliacao/${id}`);
  },
  executarRelatorio(id) {
    return APIService.apiCall().patch(`/vinculo-conciliacao/executar/${id}`);
  },
  baixarResultado(id, config = {}) {
    return APIService.apiCall().get(`/vinculo-conciliacao/baixar-resultado/${id}`, { responseType: 'blob', ...config });
  }
};
